<div class="avatar {{ styleClass }} {{ randomBgColor }}">
  <ng-content select="[indicator]"></ng-content>
  <img *ngIf="avatar?.url" alt="avatar" class="avatar-img" [src]="avatar?.url" />
  <div *ngIf="showInitials" class="avatar-initial">{{ initials }}</div>
</div>
